import { FaBluesky, FaDiscord, FaFacebookF, FaLinkedinIn, FaXTwitter } from "react-icons/fa6";

import { DISCORD_INVITE_URL } from "#/lib/discordInvite";

const SOCIAL_LINKS = [
  {
    href: DISCORD_INVITE_URL,
    label: "Discord",
    Icon: FaDiscord,
  },
  {
    href: "https://x.com/PlayDailyWars",
    label: "X (Twitter)",
    Icon: FaXTwitter,
  },
  {
    href: "https://bsky.app/profile/playdailywars.bsky.social",
    label: "Bluesky",
    Icon: FaBluesky,
  },
  {
    href: "https://facebook.com/playdailywars",
    label: "Facebook",
    Icon: FaFacebookF,
  },
  {
    href: "https://www.linkedin.com/company/playdailywars/",
    label: "LinkedIn",
    Icon: FaLinkedinIn,
  },
] as const;

export function FooterSocialLinks() {
  return (
    <div className="flex items-center gap-2">
      {SOCIAL_LINKS.map(({ href, label, Icon }) => (
        <a
          key={href}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className={
            "transition-opacity hover-supported:opacity-80 inline-flex size-6 sm:size-7 items-center justify-center rounded-sm bg-foreground text-background"
          }
        >
          <Icon className={"size-3 sm:size-4"} aria-hidden="true" />
        </a>
      ))}
    </div>
  );
}
